import { JwtConfig } from '@auth0/angular-jwt';
import { Configuration, ConfigurationParameters } from '@digitalforest/ngx-oak-api';
import { environment } from '../environments/environment';
import { AuthService } from './auth.service';

export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: environment.API_BASE_PATH,
  };

  return new Configuration(params);
}

export function tokenProvider(authService: AuthService): JwtConfig {
  return {
    tokenGetter: () => {
      return authService.getToken();
    },
    allowedDomains: environment.ALLOWED_DOMAINS,
    disallowedRoutes: [],
  };
}
